const en = {
  home: 'Home',
  shopping_guide: 'Shopping Guide',
  browse_categories: 'Browse Categories',
  newsletter: 'Newsletter',
  subscribe: 'Subscribe',
  view_all_guides: 'View All Guides',
  read_article: 'Read article',
  read_full_guide: 'Read full guide',
  start_shopping: 'START SHOPPING',
  visit_kaspreadsheet: 'VISIT KASPREADSHEET',
};

export default en;